import { createContext, useContext, useState, useEffect } from "react";
import apiClient from "../components/apiClient"; // update this path to your actual apiClient

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const fetchCartCount = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const cartRes = await apiClient.get("/cart", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const serverCart = cartRes.data.cartItems || [];
      const totalItems = serverCart.reduce(
        (total, item) => total + parseInt(item.jumlah, 10),
        0
      );

      setCartCount(totalItems);
      setIsLoggedIn(true);
    } catch (error) {
      console.error("Failed to fetch cart count", error);
    }
  };

  const clearCart = () => {
    setCartCount(0);
    localStorage.removeItem("cart");
  };

  useEffect(() => {
    fetchCartCount();
  }, []);

  return (
    <CartContext.Provider
      value={{ cartCount, setCartCount, fetchCartCount, clearCart, isLoggedIn, setIsLoggedIn }}
    >
      {children}
    </CartContext.Provider>
  );
};
